import { useSelectedPolicy } from "data/ss-data-hooks";
import { usePolicyFeature } from "utils/policy-feature-map";

export const SageSureOneBadge = () => {
  const show = usePolicyFeature("sageSureOneDisplay");
  const { data } = useSelectedPolicy();
  if (!show || !data?.sageSureOne) return null;
  if (data?.sageSureOne.level === "SELECT") {
    return (
      <img
        src="/assets/images/ss1-badge-select.svg"
        alt="SageSure One Select"
      />
    );
  } else if (data?.sageSureOne.level === "RESERVE") {
    return (
      <img
        src="/assets/images/ss1-badge-reserve.svg"
        alt="SageSure One Select"
      />
    );
  }
  return null;
};
